const setForwardDefaults = (state, forwardDefaults) => {
  state.forwardDefaults = forwardDefaults;
};

const setForwardDocument = (state, forwardDocument) => {
  state.forwardDocument = forwardDocument;
};

export default {
  setForwardDefaults,
  setForwardDocument,
};
